// extracted by mini-css-extract-plugin
module.exports = {"inpBox":"style_inpBox__1z5DN","inpSearch":"style_inpSearch__X9Wyg","btnSearch":"style_btnSearch__-1i60"};